export default __webpack_public_path__ + "static/media/risk-bars-very-high.612a980c.svg";